module.exports = __webpack_public_path__ + "img/title0.61050ab7.png";